(() => {
  if (window.gpCartWhatsAppReady) return;
  window.gpCartWhatsAppReady = true;
  function message(cart, origin) {
    const money = value => new Intl.NumberFormat('es-CO', {style:'currency',currency:cart.currency || 'COP'}).format(value / 100);
    const rows = ['Hola, quiero consultar estos productos de Germán Patiño:'];
    cart.items.forEach((item, index) => {
      rows.push('', (index + 1) + '. ' + item.product_title);
      if (item.options_with_values) item.options_with_values.forEach(option => {
        if (option.value !== 'Default Title') rows.push(option.name + ': ' + option.value);
      });
      else if (item.variant_title && item.variant_title !== 'Default Title') rows.push(item.variant_title);
      rows.push('Cantidad: ' + item.quantity);
      Object.entries(item.properties || {}).forEach(([key, value]) => {
        if (!key.startsWith('_') && value) rows.push(key + ': ' + value);
      });
      rows.push(new URL(item.url, origin).href);
    });
    rows.push('', 'Subtotal de productos: ' + money(cart.total_price), 'Envío por cotizar. Destino (país y ciudad):');
    return rows.join('\n');
  }
  document.addEventListener('click', async event => {
    const link = event.target.closest('[data-gp-cart-whatsapp]');
    if (!link) return;
    event.preventDefault();
    if (link.dataset.busy === 'true') return;
    link.dataset.busy = 'true';
    link.setAttribute('aria-busy', 'true');
    const original = link.textContent;
    link.textContent = 'Preparando tu carrito…';
    const error = link.parentElement.querySelector('[data-gp-whatsapp-error]');
    if (error) error.hidden = true;
    const tab = window.open('about:blank', '_blank');
    if (tab) tab.opener = null;
    try {
      const response = await fetch(link.dataset.cartUrl, {credentials:'same-origin',cache:'no-store'});
      if (!response.ok) throw new Error('cart');
      const cart = await response.json();
      if (!cart.items || !cart.items.length) throw new Error('empty');
      const url = 'https://wa.me/573236157777?text=' + encodeURIComponent(message(cart, link.dataset.shopUrl));
      if (tab) tab.location.replace(url);
      else window.location.assign(url);
    } catch (e) {
      if (tab) tab.close();
      if (error) {
        error.textContent = 'No pudimos cargar el carrito. Actualiza la página e inténtalo de nuevo.';
        error.hidden = false;
      }
    } finally {
      delete link.dataset.busy;
      link.removeAttribute('aria-busy');
      link.textContent = original;
    }
  });
})();